export const TOPIC_ANALYTICS_API_ROUTES = {
    TOPIC_ANALYSIS: '/test/topicAnalysis',
}